export const getActualShippingDateInfo = (dateFrom, dateTo, isValidInterval) => {
    let actualDateFrom = dateFrom;
    let actualDateTo = dateTo;

    if (!isValidInterval) {
        actualDateFrom = dateFrom ? dateFrom : dateTo;
        actualDateTo = null;
    } else if (dateFrom > dateTo) {
        [actualDateFrom, actualDateTo] = [dateTo, dateFrom]
    }

    return {shippingDateFrom : actualDateFrom, shippingDateTo: actualDateTo};
}